/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SignOut/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import EnsureUrl from 'DesignSystem/EnsureUrl/react'
import FlyingRoger from 'DesignSystem/Images/FlyingRoger/index'
import React from 'react'
import SubTitle from 'DesignSystem/SubTitle/index'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'
import styles from './view.module.css'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function SignOut({
  children,
  viewPath = "/App/Auth/SignOut"
  
}) {
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let dtSpaceL = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.l'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<EnsureUrl
  viewPath={`${viewPath}/EnsureUrl`}
/>
<div
  data-testid="SignOut.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="SignOut.Vertical:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical1}`}
>
<div
  data-testid="SignOut.Vertical:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical2}`}
>
<FlyingRoger
  viewPath={`${viewPath}/FlyingRoger`}
 width={150}
 height="auto"
/>
</div>
</div>
<SubTitle
  viewPath={`${viewPath}/SubTitle`}
 marginRight={dtSpaceL}
 marginLeft={dtSpaceL}
 textAlign="center"
 marginTop={dtSpaceS}
 lineHeight="20px"
 text="You've been logged out successfully!"
/>
<div
  data-testid="SignOut.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="primary"
 marginTop={dtSpaceL}
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, '../SignIn'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, '../SignIn'))}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Sign In"
/>
)}
</TysiaButton>
</div>
</div>
{children}
</React.Fragment>)
}